import styled from 'styled-components';
import { tokens } from 'styles/tokens';

export const TitleContainer = styled.span`
    border-bottom: 1px solid ${tokens.action.hover};
`;

export function getKCFAcademyUrl(): string {
    return `https://academy.kcftech.com/learn`;
}
